<template>
	
	<div>
		
		<!-- 리스트 -->
		<div class="list-content">
			
			<ul class="type-gallery row row-cols-1 row-cols-sm-2 row-cols-lg-4">
				
				<li class="col" :id="'item-' + item.emIdx" v-for="(item, index) in eduList">
					<a href="javascript:;" @click="goLearn(item)">
						<div class="thumb-box" v-if="item.thumbnail != null && item.thumbnail !== ''" :style="'background-image: url(' + item.thumbnail + ');'"></div>
						<div class="thumb-box" v-else style="background-image:url(/ssflex/assets/img/common/img_thumb.svg);"></div>
						<div class="text-box">
							<div class="cate bedge-line">
								<span class="prim" v-if="item.cateCode != null">{{ item.cateCodeVO.codeName }}</span>
								<span class="sec" v-if="item.isMajor">주요교육</span>
							</div>
							<h3 class="tit">
								{{ item.shortTitle }} {{ item.eduTitle }}
							</h3>
							<p class="desc">
								{{ item.introduce }}
							</p>
							<ul class="info">
								<li class="like"><span class="blind">좋아요</span>{{ item.wishCount }}</li>
								<li class="view"><span class="blind">조회수</span>{{ item.views }}</li>
							</ul>
						</div>
					</a>
				</li>
			
			</ul>
		</div>
	
	</div>

</template>

<script>

export default {
	name: "eduList",
	props: {
		forApp: {
			type: Boolean,
			default: false,
		},
		eduList: Array,
	},
	data() {
		
		
		
		return {
			//eduList: [],
			eduCount: 0,
		}
	},
	created() {
	
	},
	mounted() {
	},
	methods: {
		
		
		goLearn( _item ) {
			if ( this.forApp ) {
				this.goAppEducation(_item.cateCode, _item.emIdx)
			}
			this.$eventBus.$emit("goLearning", _item.emIdx)
		},
		
	},
}
</script>

<style scoped>

</style>
